module.exports = __webpack_public_path__ + "img/cat-icon.bf09dff0.svg";